/**
 * Post Content Image Fallback Render
 *
 * Renders placeholder elements used when post content images fail to load.
 */

import { Placeholders } from "../../constants/placeholders";
import { postContentImageFallbackForm } from "./post-content-image-fallback-form";

class PostContentImageFallbackRender {
    public createFallbackElement(): HTMLDivElement {
        const fallback = document.createElement("div");
        fallback.className = "board-placeholder post-content-image-fallback";
        fallback.setAttribute("data-placeholder-variant", "no-image");
        fallback.innerHTML = `
            <div class="placeholder-icon text-icon"><i class="bi bi-paperclip"></i></div>
            <div class="placeholder-text final-placeholder">${Placeholders.NO_IMAGE}</div>
        `;
        return fallback;
    }

    public replaceBrokenImage(img: HTMLImageElement): void {
        if (!(img instanceof HTMLImageElement)) return;
        if (img.dataset.postContentFallbackDone === "1") return;

        img.dataset.postContentFallbackDone = "1";

        const postContent = postContentImageFallbackForm.getClosestPostContent(img);
        if (!(postContent instanceof HTMLElement)) return;

        if (postContentImageFallbackForm.getClosestSnsContent(img)) return;

        const fallback = this.createFallbackElement();
        img.replaceWith(fallback);
    }
}

export { PostContentImageFallbackRender };
